import { render, staticRenderFns } from "./faq-wrapper.vue?vue&type=template&id=775a4b63&scoped=true"
import script from "./faq-wrapper.vue?vue&type=script&lang=ts"
export * from "./faq-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./faq-wrapper.vue?vue&type=style&index=0&id=775a4b63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a4b63",
  null
  
)

/* custom blocks */
import block0 from "./faq-wrapper.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExpansionPanels: require('/home/runner/work/frontpages/frontpages/component-library/src/components/molecules/accordion/expansion-panels.vue').default,HDivider: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/dividers/h-divider.vue').default,HIcon: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/icons/h-icon.vue').default,HButton: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/buttons/h-button.vue').default})
